import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Divider, Grid2 } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import QRCode from 'react-qr-code';
import {Mysection, MydivCOM,MydivRUP,Myrow,cardDownload,sanitizetel,initials,capitalize,openURL,EneaButton,parseToLink } from './Style';
import DownloadIcon from '@mui/icons-material/Download';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {Avatar} from '@mui/material';
import {Chip, Stack,Box,Tab,Tabs} from '@mui/material';
import { Fragment, useEffect } from 'react';
import { blue, green,red} from '@mui/material/colors';
import { useState,useMemo } from 'react';

const cols=(obj)=>{
    return {
        id:obj.id,
        garaid:obj.gara_id,
        link:obj.link_scheda_gara,
        lottoid:obj.lotto_id,
        oggapp:obj.oggetto_appalto,
        dtinizio:obj.dt_inizio,
        chiusura:obj.dt_fine,

    }
}

const AvvisoCard = ({handleclose,detail,showesiti})=>{
        // console.log("avviso detail are: "+JSON.stringify(detail));
    

        return (        
                <Card>
                <CardContent>
                    <Mysection text="sintesi"/>
                    <Grid2 container alignItems='center' spacing={{ xs:0 , md:2}} columns={{xs:4, sm:4, md:8, xl:12}} rowGap={3} >
                    <Grid2 size={4}>
                        <Myrow name="id avviso" val={detail.id}/> 
                        <Myrow name="importo netto" val={new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(detail.importo_base_asta)||'-'}/>
                        <Myrow name="criterio di aggiudicazione" val={detail.criterio_nome}/>
                        
                    </Grid2>
                    <Grid2 size={4}>
                        <Myrow name="UO richiedente" val={detail.uo_richiedente}/>
                        <Myrow name="note" val={detail.note}/>
                        <Myrow name="scadenza offerta" val={new Date(detail.scadenza_selezione).toLocaleDateString()||'-'}/>
                        
                    </Grid2>
                    <Grid2 size={4}>
                        <Myrow name="procedura di aggiudicazione" val={detail.procedura_nome}/>
                        <Myrow name="criterio di aggiudicazione" val={detail.criterio_nome}/>
                
                        
                    </Grid2>
                    <Grid2 size={5}>
                        <Stack direction="row" spacing={5} sx={{p:2}} alignItems="center">
                        <p>Dati Responsabile Procedimento</p>
                            <MydivRUP obj={detail}/>
                        </Stack>
                       
                    </Grid2>
                   
                    </Grid2>    
                    <Divider/>
                    {detail.allegati.length>0 && (
                    <Fragment>
                        <Mysection text="allegati"/>
                        
                        <Grid2 container spacing={10} rowGap={2}>
                            {detail.allegati.map( o=>{
                                return (
                                <Grid2 key={uuidv4()}>
                                    <Card>
                                        <Typography variant="h6" component="div">
                                            {o.tag}
                                        </Typography>
                                        <CardContent>
                                            {cardDownload(o)}
                                        </CardContent>
                                    </Card>
                                </Grid2>)
                            })}
                        </Grid2>
                    </Fragment>)}
                    <Divider/>
                    
                </CardContent>
                
                <CardActions>
                    <Button size="large" onClick={handleclose}>Chiudi</Button>
                </CardActions>
                </Card>)

};
export { AvvisoCard };